import { render, staticRenderFns } from "./UpdateServer.vue?vue&type=template&id=b81155f0&scoped=true"
import script from "./UpdateServer.vue?vue&type=script&lang=js"
export * from "./UpdateServer.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./UpdateServer.vue?vue&type=style&index=1&id=b81155f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81155f0",
  null
  
)

export default component.exports